import { useMemo } from "react";
import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";
import componentsOverride from "../theme/overrides";

export default function ThemeColorPresets({ children }: any) {
    const defaultTheme = useTheme();

    const themeOptions = useMemo(
        () => ({
            ...defaultTheme,
            palette: {
                ...defaultTheme.palette,
            },
            customShadows: {
                ...defaultTheme.customShadows,
            },
        }),
        [defaultTheme]
    );

    const theme = createTheme(themeOptions);
    theme.components = componentsOverride(theme);

    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
